export class BlogAuthorModel {
  id: string;
  name: string;
  avatarList: string[];
}
